<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 系统配置
                </el-breadcrumb-item>
                <el-breadcrumb-item>商户配置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
         <el-card shadow="hover"  class="searchCard" >  
                <el-input v-model.trim="query.payName" placeholder="商户名称" class="handle-input mr10"></el-input> 
                <el-select v-model="query.payType"  placeholder="商户类型" clearable class="handle-select mr10">
                            <el-option value="" label="全部"  />   
                            <el-option value="2" label="微信商户"  /> 
                            <el-option value="3" label="支付宝商户"  /> 
                        </el-select>
                <el-button  type="primary"  icon="el-icon-lx-roundadd"  class="handle-del mr10"   @click="addBind" >新增商户</el-button>  
   
                <el-button type="success" icon="el-icon-search"    @click="handleSearch">搜索</el-button>
                <el-button type="warning" icon="el-icon-refresh"    @click="refreshSearch">重置</el-button>
               
         </el-card>
         <el-card shadow="hover"  class="containCard" >  
            <el-table :data="tableData" class="table"  ref="multipleTable" header-cell-class-name="table-header"   >
                <!--<el-table-column type="selection" width="35" align="center"></el-table-column>--> 
                <el-table-column prop="id" width="50" align="left" label="ID"></el-table-column>
                <el-table-column prop="payName" min-width="150" align="left" label="商户名称"></el-table-column>
                <el-table-column prop="payType" min-width="75" align="left" label="商户类型">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.payType=='2'?'success':'primarys'" >{{scope.row.payType=='2'?'微信商户':scope.row.payType=='3'?'支付宝商户':'其它支付'}}</el-tag>
                    </template> 
                </el-table-column> 
                <el-table-column prop="useType" min-width="80" align="left" label="支付类型">
                    <template slot-scope="scope">
                        <el-link>{{scope.row.useType==1?'扫码支付':scope.row.useType==2?'h5支付':scope.row.useType==3?'公众号支付':scope.row.useType==4?'小程序支付':'未知支付'}}</el-link>
                    </template> 
                </el-table-column> 
                <el-table-column prop="payNum" min-width="100" align="left" label="商户号"> </el-table-column>
                <el-table-column prop="appId" min-width="150" align="left" label="APPID"> </el-table-column>
                <el-table-column prop="payTotal" min-width="100" align="center" label="累计收款"> </el-table-column>
                <el-table-column prop="channelStatus" min-width="90" align="center" label="商户状态">
                    <template slot-scope="scope">
                        <el-tooltip :content="scope.row.status=='1'?'启用':'停用'" placement="top">
                            <el-switch @change="handleStatus(scope.$index, scope.row)"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip> 
                    </template> 
                </el-table-column>  
                <el-table-column prop="createTime" min-width="160" align="left"  label="添加时间"> </el-table-column>  
                <el-table-column label="操作" min-width="130" align="center" fixed="right">
                    <template slot-scope="scope">  
                        <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>
                    </template>
                </el-table-column>
                  
            </el-table>
            <div class="pagination">
                <el-pagination 
                    background
                    layout="total,  prev, pager, next" 
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange" 
                ></el-pagination>
            </div>
         </el-card>
        
     
        <!-- 新建代理渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="新增商户" :modal-append-to-body='false' :visible.sync="addPlusVisible" top="30px" width="520px">
            <el-form ref="form1" :model="form1" label-width="90px">
                <el-form-item label="商户名称" >
                    <el-input  v-model.trim="form1.payName"  placeholder="必填"></el-input>   
                </el-form-item>  
                <el-form-item label="商户类型" >
                    <el-radio-group v-model.trim="form1.payType" >
                            <el-radio-button label="2">微信商户</el-radio-button> 
                            <el-radio-button label="3">支付宝商户</el-radio-button> 
                        </el-radio-group>    
                </el-form-item>  
                <el-form-item label="商户号" v-if="form1.payType==2" >
                    <el-input  v-model.trim="form1.payNum"  placeholder="必填"></el-input>   
                </el-form-item>  
                <el-form-item label="APPID" >
                    <el-input  v-model.trim="form1.appId"  placeholder="必填"></el-input>   
                </el-form-item>  
                
                <el-form-item label="APIV3密钥"  v-if="form1.payType==2" >
                    <el-input  v-model.trim="form1.secret"  placeholder="请填写32位APIV3密钥"></el-input>   
                </el-form-item>   
                <el-form-item label="证书序列号"  v-if="form1.payType==2" >
                    <el-input v-model.trim="form1.payCertNum"  placeholder="必填"></el-input>   
                </el-form-item> 
                <el-form-item label="证书key" v-if="form1.payType==2" >
                    <el-input  type="textarea" autosize v-model.trim="form1.payKey"  placeholder="必填"></el-input>   
                </el-form-item>  
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addPlusVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">确 定</el-button>
            </span>
        </el-dialog>
  

     
        <!-- 编辑代理渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="编辑商户" :modal-append-to-body='false' :visible.sync="editPlusVisible" top="30px" width="520px">
            <el-form ref="form" :model="form3" label-width="90px">
                <el-form-item label="商户名称" >
                    <el-input  v-model.trim="form3.payName"  placeholder="必填"></el-input>   
                </el-form-item>  
                <el-form-item label="商户类型" >
                    <el-radio-group v-model.trim="form3.payType" >
                            <el-radio-button label="2">微信商户</el-radio-button> 
                            <el-radio-button label="3">支付宝商户</el-radio-button> 
                        </el-radio-group>    
                </el-form-item> 
                 <el-form-item label="支付方式" >
                    <el-radio-group v-model.trim="form3.useType" >
                            <el-radio-button label="1">扫码支付</el-radio-button> 
                            <el-radio-button label="2">H5支付</el-radio-button> 
                            <el-radio-button label="3" v-if="form3.payType==2">公众号支付</el-radio-button> 
                            <el-radio-button label="4">小程序支付</el-radio-button> 
                        </el-radio-group>    
                </el-form-item>  
                <el-form-item label="商户号" v-if="form3.payType==2" >
                    <el-input  v-model.trim="form3.payNum"  placeholder="必填"></el-input>   
                </el-form-item>  
                <el-form-item label="APPID" >
                    <el-input  v-model.trim="form3.appId"  placeholder="必填"></el-input>   
                </el-form-item>  
                <el-form-item label="应用私钥"  v-if="form3.payType==3" >
                    <el-input type="textarea" autosize v-model.trim="form3.fb1"  placeholder="请填写应用私钥"></el-input>   
                </el-form-item>
                <el-form-item label="应用公钥"  v-if="form3.payType==3" >
                    <el-input  type="textarea" autosize  v-model.trim="form3.fb2"  placeholder="请填写应用公钥"></el-input>   
                </el-form-item>
                <el-form-item label="SECRET"  v-if="form3.payType==2" >
                    <el-input  v-model.trim="form3.secret"  placeholder="请填写SECRET"></el-input>   
                </el-form-item>  
                <el-form-item v-if="form3.payType==2" label="公众号密钥" >
                    <el-input   v-model.trim="form3.appSecret"  placeholder="公众号支付必填"></el-input>   
                </el-form-item>  
                <el-form-item label="证书序列号"  v-if="form3.payType==2" >
                    <el-input v-model.trim="form3.payCertNum"  placeholder="必填"></el-input>   
                </el-form-item>
                <el-form-item label="证书cert"  v-if="form3.payType==2" >
                    <el-input type="textarea" autosize  v-model.trim="form3.payCert"  placeholder="必填"></el-input>   
                </el-form-item> 
                <el-form-item label="证书key" v-if="form3.payType==2" >
                    <el-input  type="textarea" autosize v-model.trim="form3.payKey"  placeholder="必填"></el-input>   
                </el-form-item>  
            </el-form>
            <span slot="footer" class="dialog-footer" >
                <el-button @click="editPlusVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
         

         <!-- 代理详情弹出框 --> 
        <el-dialog :title="form2.channelName " :modal-append-to-body='false' :visible.sync="detailVisible" top="50px" min-width="400px">
            <el-form ref="form2" :model="form2" label-width="90px">  
                <el-form-item label="渠道名称" style="display:inline-block;width:50%;float:left;">
                    <span style="margin-left:10px;">{{form2.channelName}}</span>
                </el-form-item>  
                <el-form-item label="归属运营商" style="display:inline-block;width:50%;float:left;" > 
                    <span style="display:inline-block;margin-left:10px;" >
                        {{form2.belongType==='1'?'移动':form2.belongType==2?'联通':form2.belongType==3?'电信':form2.belongType==4?'广电':'聚合'}}
                    </span>
                </el-form-item> 
                <el-form-item label="渠道类型" style="display:inline-block;width:50%;float:left;" > 
                    <span style="display:inline-block;margin-left:10px;" >
                        {{form2.channelType==1?'第三方渠道':'运营商渠道'}}
                    </span>
                </el-form-item>   
                <el-form-item label="渠道系统" style="display:inline-block;width:50%;float:left;">
                    <span  style="display:inline-block;margin-left:10px;" >{{form2.channelFag}}</span>
                </el-form-item>   
                <el-form-item label="备注" style="display:inline-block;width:50%;float:left;">
                    <span  style="display:inline-block;margin-left:10px;" >{{form2.detail}}</span>
                </el-form-item> 
                <el-form-item label="渠道轮询" style="display:inline-block;width:50%;float:left;">
                    <span  style="display:inline-block;margin-left:10px;" >{{form2.channelTask==1?'开启':'关闭'}}</span>
                </el-form-item> 
                <el-form-item label="账户" style="display:inline-block;width:50%;float:left;">
                    <span  style="display:inline-block;margin-left:10px;" >{{form2.appId}}</span>
                </el-form-item>
                <el-form-item label="充值复网" style="display:inline-block;width:50%;float:left;">
                    <span  style="display:inline-block;margin-left:10px;" >{{form2.netLink==1?'开启':'关闭'}}</span>
                </el-form-item> 
                <el-form-item label="密码 "  style="display:inline-block;width:50%;float:left;">
                    <span  style="display:inline-block;margin-left:10px;" >{{form2.appSecret}} </span>
                </el-form-item>   
                <el-form-item label="渠道状态" style="display:inline-block;">
                    <span  style="display:inline-block;margin-left:10px;" >{{form2.channelStatus==1?'启用':'停用'}}</span>
                </el-form-item>  
                <el-form-item label="Token" style="display:inline-block;width:100%;">
                    <span  style="display:inline-block;margin-left:10px;" >{{form2.appToken}}</span>
                </el-form-item>
                <el-form-item label="key" style="display:inline-block;width:100%;">
                    <span style="display:inline-block;margin-left:10px;" >{{form2.appKey}}</span>
                </el-form-item>
                <el-form-item label="接口地址" style="display:inline-block;width:100%;">
                    <span style="display:inline-block;margin-left:10px;" >{{form2.apiUrl}}</span>
                </el-form-item>
                 
            </el-form> 
        </el-dialog>
    </div>
</template>

<script>
import {fetchData,saveForm,handDelete,changeForm,changeStatus} from '../../api/paySet';  
export default {

    data() {
        return {  
            Timeout:'',
            mid:'', 
            secret:'',
            stationId:'', 
            loginName:'',
            activeNames:1,
            select:{ option:'',  },
            sendSms:{
                code:'', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             },
            
            query: { 
                pageIndex: 1,
                pageSize: 10, 
            },
            tableData: [],
            tableData2: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false, 
            dirVisible:false,
            row:{},
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {
                payType:'2',
                useType:'1', 
            },
            form2: {   },
            form3: {   },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () {
        this.mid = localStorage.getItem('ms_mid');
        this.secret = localStorage.getItem('ms_secret');
        this.stationId = localStorage.getItem('ms_stationId');  
        this.loginName = localStorage.getItem('ms_username');  
        //查询列表
        this.getData();  
        this.getSelect();
    },

    methods: {  
        // 触发搜索按钮 
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'payName', '');  
            this.$set(this.query, 'payType');   
        }, 
     
        //触发刷新按钮
        refresh(){
            history.go(0);
            
        },

        //获取下拉框数据
        getSelect(){  
            this.select.stationId = this.stationId; 
            this.select.mid = this.mid;
            fetchSelect(this.select).then(res => {   
                if(res.code=='200'){ 
                    this.select.option = res.data; 
                }
            });
        }, 

        //查询
        getData(){ 
            this.query.stationId = this.stationId;  
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        },
        //渠道字典表
        channelDir(){
            this.dirVisible=true;
            fetchDataDir(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData2 = res.data;   
                }else{
                    this.$message("暂无数据");
                } 
                
            });

        },
        //选择不同渠道类型显示不同弹框
        addChange(){  
            if(this.form1.channelType==1){
                this.addVisible=false;
                this.addPlusVisible=true;
            }
            if(this.form1.channelType==0){
                this.addVisible=true;
                this.addPlusVisible=false
            }
        }, 

        // 新增渠道
        addBind() {
            this.addPlusVisible = true; 
        },
        //保存新增
        saveForm() {  
            this.form1.mid = this.mid;
            this.form1.stationId = this.stationId;  
            if( !this.form1.payName ){
                this.$message.error("请填写商户名称");
                return;
            }
            if( !this.form1.payType ){
                this.$message.error("请选择商户类型");
                return;
            } 
            if( !this.form1.useType ){
                this.$message.error("请选择支付方式");
                return;
            } 
            if( !this.form1.appId ){
                this.$message.error("请填写APPId");
                return;
            }   
            saveForm(this.form1).then(res => {
                if(res.code=='200'){
                    this.addVisible = false;
                    this.addPlusVisible = false;
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                } 
            });
        },

        

        // 编辑操作
        handleEdit(index, row) {  
            this.editPlusVisible = true;
            this.form3 = row;   
        },

         
        // 保存更改
        saveEdit() {  
            this.form3.mid = this.mid;
            this.form3.stationId = this.stationId;  
            changeForm(this.form3).then(res => {
                if(res.code=='200'){
                    this.editVisible = false;
                    this.editPlusVisible = false;
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) { 
            let data = {};
            data.id = row.id;
            data.status = row.status;
            data.stationId = this.stationId; 
            data.mid = this.mid;  
            changeStatus(data).then(res => {
                if(res.code=='200'){ 
                    this.$message.success(res.message); 
                    this.getData();
                }else{ 
                    this.$message.error(res.message);
                    if(row.status=='1'){
                        row.status = '0';
                    }else{
                        row.status = '1';
                    } 
                } 
            }); 
        },
 
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete(index, row) {  
            this.form.id=row.id; 
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            // 二次确认删除
            this.$confirm('去顶要删除该商户吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功');  
                        this.getData();
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 120px;
    display: inline-block;
}

.handle-input {
    width: 180px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
